import { put, select, apply, takeLatest, call } from 'redux-saga/effects'
import { fetchTopics } from 'containers/TrendingTopics/actions'
import { selectTrendingDeviceId } from 'containers/TrendingTopics/selectors'
import Cookies from 'js-cookie'
import { loadRecents } from 'containers/RecentTopics/actions'
import { loadLayout } from 'containers/Home/actions'
import { loadFavourites } from 'containers/Favourites/actions'
import Raven from 'raven-js'
import { fetchUser, fetchOptions, fetchCustomerLabels } from './actions'
import { selectCurrentPhone } from './selectors'
import { UPDATE_PHONE_ID, FETCH_USER } from './constants'
import { apiFetchOptions } from './services.js'
import { fetchDevices } from '../DeviceSlider/actions'
import qs from 'query-string'
import { getCustomers, getCustomer } from 'helpers/utils'
import * as KEYS from '../../constants/keys'

function* deviceWorker(action) {
  const state = yield select()
  const phoneId = selectTrendingDeviceId(state)

  if (phoneId !== action.phoneId) {
    yield put(fetchTopics.request(action.phoneId))
  }

  if (action.phoneId) {
    Cookies.set(KEYS.DEVICE_ID, action.phoneId)

    const device = selectCurrentPhone(state)
    Cookies.set(KEYS.DEVICE_OS, device.os)
  } else {
    Cookies.remove(KEYS.DEVICE_ID)
    Cookies.remove(KEYS.DEVICE_OS)
  }
}

function* fetchUserWorker(action) {
  try {
    const user = yield apply(action.auth, action.auth.getProfile)
    const query = qs.parse(location.search)

    if (query.customer) {
      const validQuery = getCustomers(user).includes(query.customer)
      if (!validQuery) {
        return action.auth.logout()
      }
      sessionStorage.setItem('customer', query.customer)
    }

    localStorage.setItem(KEYS.AUTH_USER_ID, user.user_id)
    localStorage.setItem(KEYS.AUTH_USER_EMAIL, user.email)
    // TODO: customer is saved in plain text and can be changed, find a way to secure this.
    const customer = getCustomer()

    if (!customer) {
      sessionStorage.setItem(
        'customer',
        user.careassist && user.careassist.name
      )
    }

    if (user.user_metadata) {
      yield put(loadRecents(user.user_metadata.recent_topics || []))
      yield put(loadFavourites(user.user_metadata.favourites || []))

      if (user.user_metadata.layout) {
        const layout = [...new Set([...user.user_metadata.layout, 'launch'])]
        yield put(loadLayout(layout))
      }
    }

    Raven.setUserContext({
      email: user.email,
      id: user.user_id
    })

    yield put(fetchUser.success(user))
  } catch (error) {
    console.log('Auth error: ', error)
    action.auth.logout()
  }
}

function* fetchOptionsWorker(action) {
  const mainCustomer = action.user.careassist.name
  const customer = getCustomer()

  try {
    yield put(fetchOptions.request())
    const options = yield call(apiFetchOptions, customer)
    yield put(fetchOptions.success(options))
    yield fetchCustomerLabelsWorker(mainCustomer)
  } catch (e) {
    console.log('failed to fetch option', e)
    yield put(fetchOptions.failed(e.message))
  }
}

function* fetchCustomerLabelsWorker(customer) {
  yield put(fetchCustomerLabels.request())

  try {
    const options = yield call(apiFetchOptions, customer)

    if (options && options.multiCustomersDisplayNames) {
      yield put(fetchCustomerLabels.success(options.multiCustomersDisplayNames))
      return
    }
    // turn off isFetching for regular acc.
    yield put(fetchCustomerLabels.success(null))
  } catch (e) {
    console.log('failed to set Labels', e)
  }
}

export default function* defaultSaga() {
  yield takeLatest(UPDATE_PHONE_ID, deviceWorker)
  yield takeLatest(FETCH_USER.REQUEST, fetchUserWorker)
  yield takeLatest(FETCH_USER.SUCCESS, fetchOptionsWorker)
  yield takeLatest(FETCH_USER.SUCCESS, () => put(fetchDevices.request()))
}
